<template>
  <TarjetaDatos titulo="Datos Generales" tipo="naranja">
    <Campo2L :valor="siniestro.numPoliza" etiqueta="Póliza" />
    <Campo2L :valor="siniestro.lugarAccidente" etiqueta="Lugar" />
    <Campo2L :valor="siniestro.fecAccidente | dateDDMMYYYY" etiqueta="Fecha" />
    <Campo2L :valor="danios" etiqueta="Daños Vehículo" />
    <Campo2L :valor="siniestro.estado" etiqueta="Estado" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    siniestro: {
      type: Object,
      required: true
    }
  },
  computed: {
    danios() {
      if (!this.siniestro.danios || !this.siniestro.danios.length) return null;
      return this.siniestro.danios.join(", ");
    }
  }
};
</script>

<style lang="scss" scoped></style>
